import { Box, Chip, Skeleton, Typography, useTheme } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';
import zeplinColor from '../../../../../../theme/Color';
import CustomCard from '../../../../CustomCard/CustomCard';
import styles from './ContactCard.module.css';

export const ContactCard = ({
  data,
  setSelected,
  selected,
  loading,
}: {
  data: any;
  setSelected: Dispatch<SetStateAction<any>>;
  selected: any;
  loading?: boolean;
}) => {
  const theme = useTheme();

  const handleSelected = (val: any) => {
    setSelected(val);
  };

  if (loading) {
    return (
      <Box>
        <CustomCard
          styles={{
            padding: '18px',
            heigth: '93px',
            backgroundColor: zeplinColor.Neutral1,
            borderWidth: `1px 1px 1px 1px`,
            borderStyle: 'solid',
            borderColor: zeplinColor.Neutral5,
            borderRadius: '14px',
            display: 'flex',
            gap: '12px',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <Skeleton variant='rounded' width={68} height={68} />
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              flexDirection: 'column',
              gap: '8px',
              flex: 1,
            }}
          >
            <Skeleton
              variant='text'
              sx={{
                fontSize: theme.typography.body2,
                flex: 1,
              }}
            />
            <Skeleton
              variant='text'
              sx={{
                fontSize: theme.typography.body2,
                flex: 1,
              }}
            />
          </Box>
        </CustomCard>
      </Box>
    );
  }

  return (
    <Box onClick={() => handleSelected(data)}>
      <CustomCard
        styles={{
          padding: '18px',
          heigth: '93px',
          backgroundColor: zeplinColor.Neutral1,
          borderWidth: `1px 1px 1px 1px`,
          borderStyle: 'solid',
          borderColor: `${
            selected?.name === data?.name ? zeplinColor.BasicBlack : zeplinColor.Neutral5
          }`,
          borderRadius: '14px',
          display: 'flex',
          gap: '12px',
          alignItems: 'center',
          cursor: 'pointer',
        }}
      >
        <Box
          sx={{
            borderRadius: { xs: '12px', xl: '14px' },
            width: { xs: '40px', xl: '68px' },
            height: { xs: '40px', xl: '68px' },
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <Box
            sx={{
              borderRadius: '14px',
              width: { xs: '58px', xl: '68px' },
              height: { xs: '58px', xl: '68px' },
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '10px',
              backgroundColor: zeplinColor.Neutral5,
              overflow: 'hidden',
            }}
          >
            {!data.profilePicture ? (
              <Typography variant='responsiveHeading2' color={zeplinColor.Neutral6}>
                {data.name
                  .split(' ')
                  .map((n: string) => n[0])
                  .join('')
                  .toUpperCase()}
              </Typography>
            ) : (
              <img src={data.profilePicture} alt='contact' className={styles.pfp} />
            )}
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: 'column',
            gap: '8px',
            flex: 1,
          }}
        >
          <Typography variant='responsiveHeading4' style={{ textAlign: 'left' }}>
            {data?.name}
          </Typography>

          <Box
            sx={{
              display: 'flex',
              gap: '8px',
            }}
          >
            <a
              href='mailto:traviskelce@gmail.com'
              target='_blank'
              rel='noopener noreferrer'
              style={{ textDecoration: 'none' }}
            >
              {data?.email}
            </a>
          </Box>
        </Box>
        {data?.roles && (
          <Chip
            label={
              <Typography variant='responsiveLabel1' sx={{ display: 'flex', alignItems: 'center' }}>
                {data?.roles}
              </Typography>
            }
            sx={{
              bgcolor: zeplinColor.BasicBlack,
              color: zeplinColor.Neutral1,
              '&.MuiChip-root': {
                height: '22px',
                padding: '4px 8px',
                borderRadius: '50px',
              },
              '& .MuiChip-label': {
                padding: 0,
              },
            }}
          />
        )}
      </CustomCard>
    </Box>
  );
};
